import type {ReactElement} from 'react';
import {StylePresetSelectorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/style-preset-selector-control/style-preset-selector-control';
import {BORDER_RADIUS_PRESETS} from '@FormMakerReact/layout/form-maker-right-panel/sectors/submit-button-presets';
import type {SubmitButtonRoundnessControlProps} from './submit-button-roundness-control.types';

export function SubmitButtonRoundnessControl({component}: SubmitButtonRoundnessControlProps): ReactElement {
  return <StylePresetSelectorControl component={component} property="border-radius" labelKey="pmwjs_form_maker_control_roundness_label" presets={BORDER_RADIUS_PRESETS} />;
}
